import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=a0aff8ec&scoped=true&"
import script from "./AccountManagement.vue?vue&type=script&lang=js&"
export * from "./AccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=a0aff8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aff8ec",
  null
  
)

export default component.exports